
export default {
    name: 'QuestionDialog',
    data() {
        return {
            dialogVisible: false,
            content: '',
            resolver: null
        }
    },
    methods: {
        // 打开弹窗
        open() {
            this.dialogVisible = true
            let data = {
                action: {
                    id: 102,
                    title: '卖家须知'
                }
            }
            this.$api.getHagglingDetail(data).then(res => {
                if (res.success) {
                    this.content = res.data.content
                } else {
                    this.$message.error(res.info)
                }
            })
            return new Promise((resolve, reject) => {
                this.resolver = resolve
            })
        },
        // 关闭弹窗
        close() {
            this.dialogVisible = false
        },
        // 处理弹窗关闭事件
        handleClose() {
            this.dialogVisible = false
        },
        confirm() {
            this.resolver(true)
            this.dialogVisible = false
        }
    }
}
